/** API / session error code when the user has exceeded their SEEK question quota. */
export const SEEK_USER_QUESTION_LIMIT_EXCEEDED = "seek.user.question.limit_exceeded";
